import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import OrganizationsTab from './OrganizationsTab';
import UsersTab from './UsersTab';
import WebsitesTab from './WebsitesTab';
import StaffApiKeysTab from './StaffApiKeysTab';
import { useUserStore } from '../../store';

function TabPanel({ children, value, index }) {
  if (value !== index) return null;
  return <Box sx={{ mt: 3 }}>{children}</Box>;
}

export default function AdminPage() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const { user: currentUser } = useUserStore();
  const isSuperuser = Boolean(currentUser?.is_superuser);

  return (
    <Box>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          mb: 3,
        }}
      >
        {t('vadmin.title')}
      </Typography>

      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          '& .MuiTab-root': {
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 500,
            textTransform: 'none',
            fontSize: '15px',
          },
        }}
      >
        <Tab label={t('vadmin.organizations')} />
        <Tab label={t('vadmin.usersTab.tab')} data-testid="vadmin-tab-users" />
        <Tab label={t('vadmin.websites')} data-testid="vadmin-tab-websites" />
        {isSuperuser && <Tab label={t('vadmin.staffApiKeysTab.tab')} data-testid="vadmin-tab-staff-api-keys" />}
      </Tabs>

      <TabPanel value={activeTab} index={0}>
        <OrganizationsTab />
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <UsersTab />
      </TabPanel>
      <TabPanel value={activeTab} index={2}>
        <WebsitesTab />
      </TabPanel>
      {isSuperuser && (
        <TabPanel value={activeTab} index={3}>
          <StaffApiKeysTab />
        </TabPanel>
      )}
    </Box>
  );
}
